import { call, put, takeEvery } from "redux-saga/effects"
import { toast } from "react-toastify";

import { CREATE_CLIENT_ADD_LISTING, GET_CLIENT_ADD_LISTING } from "./actionTypes"

import { getClientAddListingUrl, postClientAddListing } from '../../helpers/backend_helper'

import { addClientAddListingFail, addClientAddListingSuccess, getClientAddListingFail, getClientAddListingSuccess } from "./actions"
import { take } from "lodash";
import { getClientAppointment } from "store/actions";

function* submitClientAddListing({ payload: { listing, callback } }) {
  try {

    toast.loading("Please wait...")
    const response = yield call(postClientAddListing, listing)
    yield put(addClientAddListingSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Listing Added");
      const response = yield call(getClientAddListingUrl, listing.clientId, listing.agentId)
      if(callback){
        callback(true)
      }
    yield put(getClientAddListingSuccess(response))
    } else {
      toast.dismiss();
      toast.warn(response.validationErrors[0] || "Some Error. Please try after some time");
      if(callback){
        callback(false)
      }
    }
  }
  catch (error) {

    yield put(addClientAddListingFail(error))
    if(callback){
        callback(false)
      }
  }
}


function* fetchClientAddListing({ payload: { clientId, agentId } }) {
  try {
    const response = yield call(getClientAddListingUrl, clientId, agentId)
    yield put(getClientAddListingSuccess(response))
  } catch (error) {
    yield put(getClientAddListingFail(error))
  }
}





function* addListingSaga() {
  
  yield takeEvery(CREATE_CLIENT_ADD_LISTING, submitClientAddListing)
  yield takeEvery(GET_CLIENT_ADD_LISTING, fetchClientAddListing)
 

}


export default addListingSaga
